import type { HelpFile } from '../../types/help'
import { CreateResourceTestIds } from '../../../testids/CreateResourceTestIds'

export const createResourceHelp: HelpFile = {
  docPage: '/docs/systems/resources',
  texts: {
    [CreateResourceTestIds.cardTitleCreateResource]:
      'Neue Ressource vom festgelegten Typ auf dem gewählten Zielsystem anlegen. Pflichtattribute leiten sich aus den Attributdefinitionen des Typs ab.',
    [CreateResourceTestIds.btnCancelCreateResource]: null,
    [CreateResourceTestIds.btnSubmitCreateResource]: null,
    [CreateResourceTestIds.inputResourceDisplayName]: null,
    [CreateResourceTestIds.inputResourceNativeKey]: null,
    [CreateResourceTestIds.selectClassification]: null,
    [CreateResourceTestIds.selectTargetSystem]: null,
  },
}
